<template>
	<el-scrollbar wrapClass="scrollbar-wrapper">
		<el-menu mode="vertical" :unique-opened="true" :default-active="$route.fullPath" :collapse="isCollapse"
			background-color="#304156" text-color="#ffffff" :active-text-color="activeClass" :router=true>
			<template v-for="(item, index) in menu2">
				<el-menu-item v-if="!item.children || item.children.length == 0" :index="item.path"
					:class="{ 'submenu-title-noDropdown': true }" :key="item.path">
					<svg-icon v-if="item.icon" :icon-class="item.icon"></svg-icon>
					<span v-if="item.title" slot="title">{{ item.title }}</span>
				</el-menu-item>
				<el-submenu v-else :index="index + ''" :key="item.title">
					<template slot="title">
						<svg-icon v-if="item.icon" :icon-class="item.icon"></svg-icon>
						<span v-if="item.title" slot="title">{{ item.title }}</span>
					</template>
					<template v-for="child in item.children">
						<el-submenu v-if="child.children && child.children.length > 0" :index="item.title + child.title"
							:key="child.title">
							<template slot="title">
								<svg-icon v-if="child.icon" :icon-class="child.icon"></svg-icon>
								<span v-if="child.title" slot="title">{{ child.title }}</span>
							</template>
							<template v-for="child2 in child.children">
								<el-menu-item :index="child2.path" :key="child2.path">
									<svg-icon v-if="child2.icon" :icon-class="child2.icon"></svg-icon>
									<span v-if="child2.title" slot="title">{{ child2.title }}</span>
								</el-menu-item>
							</template>
						</el-submenu>
						<el-menu-item v-else :index="child.path" :key="child.path">
							<svg-icon v-if="child.icon" :icon-class="child.icon"></svg-icon>
							<span v-if="child.title" slot="title">{{ child.title }}</span>
						</el-menu-item>
					</template>
				</el-submenu>
			</template>
		</el-menu>
	</el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import { isPerm } from '@/utils/is_perm'

export default {
	components: { SidebarItem },
	data() {
		return {
			menu_list: []
		}
	},
	computed: {
		...mapGetters([
			'sidebar',
			'menu2',
			'state_id',
			'state_name',
			'sidebar',
			'userName',
			'type',
			'biz_type',
			'level',
			'county',
			'county_name',
			'town',
			'town_name',
			'unit',
			'menu',
			'perms',
			'roles'
		]),
		isCollapse() {
			return !this.sidebar.opened
		},
		activeClass() {
			return this.IsPerm('核对管理') ? '#8cc5ff' : '#409EFF';
		},
	},

	created() {
		// )
	},
	methods: {
		IsPerm (perm_name) {
      
      
	  return isPerm(this.perms, perm_name)
  },
	}
}
</script>
<style scoped>
.svg-icon {
	width: 1.3em !important;
	height: 1.3em !important;
	vertical-align: middle !important;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue